import type { AccountantEmail, AccountantStatusType } from './accountant.types';
import type {
  AvailableCountries,
  AvailableLanguages,
  SubscriptionPlanNameEnum,
} from './users.types';
import type { PagingV2Response } from './pagination.types';
import type {
  ClientsInvitationStatus,
  InvitationStatus,
} from './organization.types';

export type WorkspaceInvitation = {
  _id: string;
  email: string;
  role: WorkspaceMemberRole;
  status: InvitationStatus;
  workspace_id: string;
  workspace_name: string;
  token: string;
  created: string;
};

export interface ClientInvitation {
  _id: string;
  from: string;
  to: string;
  status: ClientsInvitationStatus;
  expires: string;
}

export type Workspace = {
  id: string;
  name: string;
  email: string;
  country: string;
  language: string;
  address?: {
    street?: string;
    postal_code?: string;
    city?: string;
  };
  phone_number?: string;
  ITAA_Number?: string;
  created_at: string;
  updated_at: string;
};

export type TeamInvitationForm = {
  email: string;
  role?: string;
  team: string;
};

// WorkspaceMemberRole enum for invitation API
export enum WorkspaceMemberRole {
  OWNER = 'owner',
  ADMIN = 'admin',
  MEMBER = 'member',
}

export interface IWorkspaceMember {
  accountantId: string;
  emails: AccountantEmail[];
  first_name: string;
  last_name: string;
  joined_at: string;
  role: WorkspaceMemberRole;
  status: AccountantStatusType;
}
export interface IWorkspace {
  __v: number;
  _id: string;
  organization_name: string;
  name: string;
  email: string;
  country: AvailableCountries;
  language: AvailableLanguages;
  address?: {
    street?: string;
    postal_code?: string;
    city?: string;
  };
  members: IWorkspaceMember[];
  phone_number?: string;
  itaa_number?: string;
  vat_number?: string;
  created: string;
  modified: string;
  references?: {
    chift_workspace_id: string;
    stripe_workspace_id: string;
  };
  subscription?: {
    plan_internal_name: SubscriptionPlanNameEnum;
    from_platform: string;
    seats_price_id: string;
    seats_subscription_id: string;
    seats_count: number;
    start: Date;
    end: Date;
    status: {
      valid: boolean;
      auto_renew: boolean;
      did_refund: boolean;
      cancellation_reason: string;
      retry_period_end: Date;
      in_retry_period: boolean;
    };
  };
  is_admin?: boolean;
  intervatGranted?: boolean;
}
export interface GetWorkspaceInvitationsResponse {
  invitations: WorkspaceInvitation[];
  paging: PagingV2Response;
}
